import React, {useState} from 'react'
import TitleComponent from '../../components/TitleComponent/TitleComponent'
import {ToastContainer} from 'react-toastify'
import {kreirajOtpremnicuPanela, prikaziOtpremnicuPanela} from '../../api/kreirajOtpremnicu'
import notifyToast from '../../components/Toast/Toast'
import {IsporuceniPaketiModel, IsporuceniPaketiSumaModel} from '../../models/KreirajOtpremnicuModel'
import {PDFViewer} from '@react-pdf/renderer'
import KreirajOtpremnicuPdf from './components/KreirajOtpremnicuPdf/KreirajOtpremnicuPdf'
import LoadingComponent from '../../components/LoadingComponent/LoadingComponent'

const KreirajOtpremnicu = () => {
  const [brojNaloga, setbrojNaloga] = useState<string>()
  const [datum, setdatum] = useState<string>()
  const [loading, setLoading] = useState(false)
  const [isporuceniPaketi, setisporuceniPaketi] = useState<IsporuceniPaketiModel[]>()
  const [isporuceniPaketiSuma, setisporuceniPaketiSuma] = useState<IsporuceniPaketiSumaModel[]>()
  const [nalogIsporucen, setnalogIsporucen] = useState(false);
  // Get Data for Naloga and generate PDF.
  const onBtnClick = () => {
    setLoading(true)
    const payload = {
      brojNaloga,
      datum,
    }
    prikaziOtpremnicuPanela(payload)
      .then((response) => {
        if (response.data) {
          setisporuceniPaketi(response.data['isporuceniPaketi'])
          setisporuceniPaketiSuma(response.data['isporuceniPaketiSuma'])
          setnalogIsporucen(response.data['nalogIsporucen'])
        } else {
          notifyToast(false, response.message)
        }
      })
      .catch((error) => notifyToast(false, error.response.data.message))
      .finally(() => setLoading(false))
  }
  // Kreiraj btn click
  const onKreirajBtnClick = () => {
    setLoading(true)
    kreirajOtpremnicuPanela({brojNaloga})
      .then((response) => {
        onBtnClick()
        notifyToast(true, response.message)
      })
      .catch((error) => notifyToast(false, error.response.data.message))
      .finally(() => setLoading(false))
  }

  return (
    <div className='card mb-5 mb-xl-10'>
      <ToastContainer />
      <div
        className='card-header border-0 pt-6'
        role='button'
        data-bs-target='#kt_account_profile_details'
        aria-expanded='true'
        aria-controls='kt_account_profile_details'
      >
        <div className='card-title m-0'>
          <TitleComponent name='Kreiraj Otpremnicu' />
        </div>
      </div>
      <div id='kt_account_profile_details' className='collapse show'>
        <div className='card-body border-top p-9'>
          <div className='rounded border bg-light p-6 mb-8'>
            <div className='row g-5 align-items-start'>
            <div className='col-lg-4 col-md-6'>
              <label className='form-label required fw-bold fs-6'>Broj naloga</label>
              <input
                type='text'
                className='form-control form-control-lg form-control-solid'
                placeholder='Unesite broj naloga'
                value={brojNaloga}
                onChange={(e) => setbrojNaloga(e.target.value)}
              />
              <div className='text-muted fs-7 mt-2'>Broj naloga se koristi za prikaz i kreiranje otpremnice.</div>
            </div>

            <div className='col-lg-3 col-md-6'>
              <label className='form-label required fw-bold fs-6'>Datum</label>
              <input
                type='date'
                className='form-control form-control-lg form-control-solid'
                value={datum}
                onChange={(e) => setdatum(e.target.value)}
              />
              <div className='text-muted fs-7 mt-2'>Datum koji se prikazuje na otpremnici.</div>
            </div>

            <div className='col-lg-auto col-md-12 pt-lg-8'>
              <button
                className='btn btn-primary btn-lg px-8 w-100'
                onClick={onBtnClick}
                disabled={loading || !datum || !brojNaloga}
              >
                Prikazi otpremnicu
              </button>
            </div>
            </div>
          </div>

          <div className='row'>
            {loading && <LoadingComponent />}
            {isporuceniPaketi && isporuceniPaketiSuma && (
              <>
                <div className='col-12 d-flex justify-content-between align-items-center flex-wrap gap-3 mb-6'>
                  <div>
                    <div className='fw-bold fs-5 text-gray-900'>Pregled otpremnice</div>
                    <div className='text-muted fs-7'>Provjerite podatke prije kreiranja dokumenta.</div>
                  </div>
                  <button className='btn btn-info btn-lg px-8' onClick={onKreirajBtnClick} disabled={loading}>
                    Kreiraj otpremnicu
                  </button>
                </div>
                <PDFViewer width='100%' height={1200}>
                  <KreirajOtpremnicuPdf
                    isporuceniPaketi={isporuceniPaketi}
                    isporuceniPaketiSuma={isporuceniPaketiSuma}
                    nalogIsporucen={nalogIsporucen}
                    datum={datum}
                  />
                </PDFViewer>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default KreirajOtpremnicu
